// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpProjectIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpProjectIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpProjectIconOutlined = function DrrpProjectIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpProjectIconOutlinedSvg
  }));
};

DrrpProjectIconOutlined.displayName = 'DrrpProjectIconOutlined';
export default React.forwardRef(DrrpProjectIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpProjectIconOutlined.js
// module id = 2567
// module chunks = 0